<template>
  <j-modal
    class="userCon-madal"
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="分组类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="addFlag == true"
        >
          <a-radio-group
            v-decorator="[
              'groupType',
              { rules: [{ required: true, message: '请选择分组类型' }] }
            ]"
            :options="typeOptions"
          />
        </a-form-item>
        <a-form-item
          label="分组名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'groupName',
              { rules: [{ required: true, message: '请输入分组名称' }] }
            ]"
            placeholder="请输入分组名称"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="分组描述"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            v-decorator="['groupDesc', {}]"
            placeholder="请输入分组描述"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-item>
        <a-form-item
          label="同步至标签"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="
            this.addFlag &
              (channelInfo.code == 'subscribe_wechat' ||
                channelInfo.code == 'h5_trade_service')
          "
        >
          <a-switch
            v-decorator="[
              'syncTagFlag',
              {
                valuePropName: 'checked',
                rules: [{ required: true, message: '请选择同步至标签' }]
              }
            ]"
            checked-children="开"
            un-checked-children="关"
          />
        </a-form-item>
        <a-form-model-item
          label="分组关系"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="this.addFlag & (this.form.getFieldValue('groupType') == 1)"
        >
          <a-radio-group
            v-decorator="[
              'relation',
              { rules: [{ required: true, message: '请选择分组类型' }] }
            ]"
          >
            <a-radio value="and">
              与
            </a-radio>
            <a-radio value="or">
              或
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form>
      <div v-if="(this.form.getFieldValue('groupType') == 0) & this.addFlag">
        <div>
          <a-form-model
            class="ant-advanced-search-form"
            :model="searchForm"
            layout="inline"
            ref="searchForm"
          >
            <a-form-model-item
              label="昵称"
              placeholder="请输入昵称"
              prop="nikeName"
            >
              <a-input v-model="searchForm.nikeName"></a-input>
            </a-form-model-item>
            <a-form-model-item
              label="手机号"
              prop="phone"
              v-if="
                channelInfo.code == 'macroscopic_miniapp' ||
                  channelInfo.code == 'integral_miniapp'
              "
            >
              <a-input v-model="searchForm.phone"></a-input>
            </a-form-model-item>
            <a-form-model-item label="性别" prop="sex">
              <a-select
                style="width: 120px"
                placeholder="请选择"
                v-model="searchForm.sex"
              >
                <a-select-option value="1">男</a-select-option>
                <a-select-option value="2">女</a-select-option>
                <a-select-option value="0">未知</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="关注时间">
              <a-range-picker :value="createValue" @change="createChange" />
            </a-form-model-item>
            <a-form-item
              label="积分范围"
              v-if="this.channelInfo.code == 'integral_miniapp'"
            >
              <a-input
                oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
                style="width: 70px;margin-left: auto"
                placeholder="请输入人数范围"
                v-model="searchForm.countStart"
              ></a-input>
              <a>~</a>
              <a-input
                oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
                style="width: 70px;margin-left: auto"
                placeholder="请输入人数范围"
                v-model="searchForm.countEnd"
              ></a-input>
            </a-form-item>
            <a-form-model-item>
              <a-button @click="reset">重置</a-button>
              <a-button type="primary" @click="handleSearch">搜索</a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
        <!--微信用户列表-->
        <a-table
          v-if="
            this.addFlag &
              (channelInfo.code == 'subscribe_wechat' ||
                channelInfo.code == 'h5_trade_service')
          "
          ref="table"
          size="middle"
          :rowKey="record => record.openid"
          :columns="column"
          :dataSource="userList"
          :row-selection="{
            selectedRowKeys: userDataListSelections,
            onChange: userOnSelectChange
          }"
          class="j-table-force-nowrap"
          :pagination="userPagination"
          @change="userHandleTableChange"
        >
          <template slot="headimgurlslot" slot-scope="text, record">
            <div class="anty-img-wrap">
              <a-avatar
                shape="square"
                :src="getHeadImageView(record.headimgurl)"
                icon="user"
              />
            </div>
          </template>
          <template slot="sexslot" slot-scope="text, record">
            <span v-if="record.sex === '1.0'">男</span>
            <span v-if="record.sex === '2.0'">女</span>
            <span v-if="record.sex === '0.0'">未知</span>
          </template>
          <template slot="tagslot" slot-scope="text, record">
            <span>{{ getTagName(record.tagidList) }}</span>
          </template>
        </a-table>

        <!--小程序用户列表-->
        <a-table
          v-if="
            this.addFlag &
              (channelInfo.code == 'macroscopic_miniapp' ||
                channelInfo.code == 'integral_miniapp')
          "
          ref="table"
          size="middle"
          :rowKey="record => record.id"
          :columns="columnMiniApp"
          :dataSource="userList"
          :row-selection="{
            selectedRowKeys: userDataListSelections,
            onChange: userOnSelectChange
          }"
          class="j-table-force-nowrap"
          :pagination="userPagination"
          @change="userHandleTableChange"
        >
          <template slot="headimgurlslot" slot-scope="text, record">
            <div class="anty-img-wrap">
              <a-avatar
                shape="square"
                :src="getHeadImageView(record.avatarUrl)"
                icon="user"
              />
            </div>
          </template>
          <template slot="sexslot" slot-scope="text, record">
            <span v-if="record.sex === 1">男</span>
            <span v-if="record.sex === 2">女</span>
            <span v-if="record.sex === 0">未知</span>
          </template>
        </a-table>
      </div>
      <a-form-model
        v-if="(this.form.getFieldValue('groupType') == 1) & this.addFlag"
        class="ant-form-user"
        ref="dynamicValidateForm"
        :model="dynamicValidateForm"
        v-bind="formItemLayoutWithOutLabel"
      >
        <a-row
          v-for="(domain, index) in dynamicValidateForm.domains"
          :key="domain.key"
        >
          <!-- column -->
          <a-col span="7">
            <a-form-model-item
              v-bind="index === 0 ? formItemLayout : {}"
              :prop="'domains.' + index + '.column'"
              :rules="{
                required: true,
                message: '不能为空',
                trigger: 'blur'
              }"
            >
              <a-select
                v-model="domain.column"
                show-search
                placeholder="请选择"
                option-filter-prop="children"
                style="width: 160px"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in options1"
                  :key="item.key"
                  :value="item.key"
                >
                  {{ item.label }}
                </a-select-option>
                <a-select-option
                  v-if="channelInfo.code == 'integral_miniapp'"
                  value="integralNum"
                >
                  积分小程序
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- 性别 -->
          <!-- sex1 -->
          <div
            v-if="
              dynamicValidateForm.domains[index].column == undefined ||
                dynamicValidateForm.domains[index].column == 'sex'
            "
          >
            <a-col :span="7">
              <a-form-model-item
                v-bind="index === 0 ? formItemLayout : {}"
                :prop="'domains.' + index + '.sex1'"
                :rules="{
                  required: true,
                  message: '不能为空',
                  trigger: 'blur'
                }"
              >
                <a-select
                  v-model="domain.sex1"
                  show-search
                  placeholder="请选择"
                  option-filter-prop="children"
                  style="width: 160px"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in sexOptions"
                    :key="item.key"
                    :value="item.key"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <!-- 性别  2-->
            <!-- sex2 -->
            <a-col :span="7">
              <a-form-model-item
                v-bind="index === 0 ? formItemLayout : {}"
                :prop="'domains.' + index + '.sex2'"
                :rules="{
                  required: true,
                  message: '不能为空',
                  trigger: 'blur'
                }"
              >
                <a-select
                  v-model="domain.sex2"
                  show-search
                  placeholder="请选择"
                  option-filter-prop="children"
                  style="width: 160px"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in sexOptions1"
                    :key="item.key"
                    :value="item.key"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </div>

          <!-- 地区 -->
          <!-- area1 -->
          <a-col
            :span="14"
            v-if="dynamicValidateForm.domains[index].column === 'area'"
          >
            <a-form-model-item
              v-bind="index === 0 ? formItemLayout : {}"
              :prop="'domains.' + index + '.area1'"
              :rules="{
                required: true,
                message: '不能为空',
                trigger: 'blur'
              }"
            >
              <a-cascader
                :field-names="{ label: 'name', value: 'name', children: 'sub' }"
                v-model="domain.area1"
                style="width: 100%"
                placeholder="请选择地区"
                :options="areaOptions"
                change-on-select
                @change="onChange"
              />
            </a-form-model-item>
          </a-col>

          <!-- 时间 -->
          <!-- subscribeTime1 -->
          <a-col
            :span="7"
            v-if="dynamicValidateForm.domains[index].column === 'subscribeTime'"
          >
            <a-form-model-item
              v-bind="index === 0 ? formItemLayout : {}"
              :prop="'domains.' + index + '.subscribeTime1'"
              :rules="{
                required: true,
                message: '不能为空',
                trigger: 'blur'
              }"
            >
              <a-select
                v-model="domain.subscribeTime1"
                show-search
                placeholder="请选择"
                option-filter-prop="children"
                style="width: 160px"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="item in timeOptions"
                  :key="item.key"
                  :value="item.key"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- subscribeTime2 -->
          <a-col
            :span="7"
            v-if="dynamicValidateForm.domains[index].column === 'subscribeTime'"
          >
            <a-form-model-item
              v-if="
                dynamicValidateForm.domains[index].subscribeTime1 === 'between'
              "
              v-bind="index === 0 ? formItemLayout : {}"
              :prop="'domains.' + index + '.subscribeTime2'"
              :rules="{
                required: true,
                message: '不能为空',
                trigger: 'blur'
              }"
            >
              <a-range-picker
                v-model="domain.subscribeTime2"
                style="width: 160px"
                @change="
                  (value, value1) => {
                    return timeChange(value, value1, index);
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item
              v-else
              v-bind="index === 0 ? formItemLayout : {}"
              :prop="'domains.' + index + '.subscribeTime3'"
              :rules="{
                required: true,
                message: '不能为空',
                trigger: 'blur'
              }"
            >
              <a-date-picker
                v-model="domain.subscribeTime3"
                @change="
                  (value, value1) => {
                    return timeChange(value, value1, index, 2);
                  }
                "
              />
            </a-form-model-item>
          </a-col>
          <!-- 积分小程序 -->
          <!-- integralNum1 -->
          <div
            v-if="dynamicValidateForm.domains[index].column === 'integralNum'"
          >
            <a-col span="6">
              <a-form-model-item
                v-bind="index === 0 ? formItemLayout : {}"
                :prop="'domains.' + index + '.integralNum1'"
                :rules="{
                  required: true,
                  message: '不能为空',
                  trigger: 'blur'
                }"
              >
                <a-input-number v-model="domain.integralNum1" />
              </a-form-model-item>
            </a-col>
            <a-col span="1">
              ~
            </a-col>
            <!-- integralNum2 -->
            <a-col span="6">
              <a-form-model-item
                v-bind="index === 0 ? formItemLayout : {}"
                :prop="'domains.' + index + '.integralNum2'"
                :rules="{
                  required: true,
                  message: '不能为空',
                  trigger: 'blur'
                }"
              >
                <a-input-number v-model="domain.integralNum2" />
              </a-form-model-item>
            </a-col>
          </div>
          <a-icon
            v-if="dynamicValidateForm.domains.length > 1"
            class="dynamic-delete-button"
            type="minus-circle-o"
            :disabled="dynamicValidateForm.domains.length === 1"
            @click="removeDomain(domain)"
          />
        </a-row>

        <a-form-model-item v-bind="formItemLayoutWithOutLabel">
          <a-button type="dashed" style="width: 60%" @click="addDomain">
            <a-icon type="plus" /> 添加分组
          </a-button>
        </a-form-model-item>
        <!-- <a-form-model-item v-bind="formItemLayoutWithOutLabel">
          <a-button type="primary" html-type="submit" @click="submitForm('dynamicValidateForm')">
            Submit
          </a-button>
        </a-form-model-item> -->
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import {
  getAction,
  putAction,
  getFileAccessHttpUrl,
  postAction
} from '@/api/manage';
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import { areaList } from '@/utils/area';
import JDate from '@/components/jeecg/JDate';
import JImageUpload from '@/components/jeecg/JImageUpload';

const typeOptions = [
  { label: '静态分组', value: 0 },
  { label: '动态分组', value: 1 }
];
const options1 = [
  { label: '性别', key: 'sex' },
  { label: '地区', key: 'area' },
  { label: '关注时间', key: 'subscribeTime' }
];
const sexOptions = [
  { label: '等于', key: '=' },
  { label: '不等于', key: '!=' }
];
const sexOptions1 = [
  { label: '男', key: '1' },
  { label: '女', key: '2' }
];
const timeOptions = [
  { label: '之间', key: 'between' },
  { label: '大于', key: '>' },
  { label: '小于', key: '<' },
  { label: '大于等于', key: '>=' },
  { label: '小于等于', key: '<=' }
];
export default {
  name: 'WechatAppModal',
  components: {
    JDate,
    JImageUpload
  },
  data() {
    return {
      groupType: '',
      integralVal1: '',
      integralVal2: '',
      optionVal: '',
      options1,
      sexOptions,
      sexOptions1,
      timeOptions,
      typeOptions,
      areaOptions: areaList,
      userDataListSelections: [],
      createValue: [],
      userPageIndex: 1,
      userPageSize: 4,
      tagListAll: [],
      userList: [],
      channelInfo: {},
      relation: '',
      addFlag: false,
      searchForm: {
        nikeName: '',
        sex: '',
        startTime: '',
        endTime: '',
        phone: '',
        countStart: '',
        countEnd: ''
      },
      userPagination: {
        total: 0,
        pageSize: 4, //每页中显示10条数据
        showSizeChanger: false,
        pageSizeOptions: ['10', '20', '50', '100'], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_WECHAT + '/wechatApp/add',
        edit: process.env.VUE_APP_CMS_WECHAT + '/wechatApp/edit'
      },
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 }
        }
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 }
        }
      },
      dynamicValidateForm: {
        domains: []
      },
      column: [
        {
          title: 'openId',
          dataIndex: 'openid',
          align: 'center',
          key: 'openid'
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          align: 'center',
          key: 'nickname'
        },
        {
          title: '头像',
          dataIndex: 'headimgurl',
          align: 'center',
          key: 'headimgurl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' }
        },
        {
          title: '性别',
          dataIndex: 'sex',
          align: 'center',
          key: 'sex',
          scopedSlots: { customRender: 'sexslot' }
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city'
        },
        {
          title: '标签',
          dataIndex: 'tagidList',
          align: 'center',
          key: 'tagidList',
          scopedSlots: { customRender: 'tagslot' }
        },
        {
          title: '关注时间',
          dataIndex: 'subscribeTime',
          align: 'center',
          key: 'subscribeTime'
        }
      ],
      columnMiniApp: [
        {
          title: 'openId',
          dataIndex: 'openId',
          align: 'center',
          key: 'openId'
        },
        {
          title: '昵称',
          dataIndex: 'nickName',
          align: 'center',
          key: 'nickName'
        },
        {
          title: '头像',
          dataIndex: 'avatarUrl',
          align: 'center',
          key: 'avatarUrl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' }
        },
        {
          title: '性别',
          dataIndex: 'gender',
          align: 'center',
          key: 'gender',
          scopedSlots: { customRender: 'sexslot' }
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city'
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          align: 'center',
          key: 'phone'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          key: 'createTime'
        }
      ]
    };
  },
  methods: {
    timeChange(dates, dateStrings, index, type) {
      console.log(dates, dateStrings, index, type);
      let str = type != 2 ? dateStrings.join(',') : dateStrings;
      this.dynamicValidateForm.domains[index].value = str;
    },
    //获取渠道信息
    getChannelInfo(item) {
      console.log(item);
      getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/queryByCode', {
        code: item
      }).then(res => {
        if (res.success) {
          this.channelInfo = res.result;
          this.searchQuery();
        }
      });
    },
    userOnSelectChange(selectedRowKeys) {
      this.userDataListSelections = selectedRowKeys;
      console.log(this.userDataListSelections);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      let index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    addDomain() {
      this.dynamicValidateForm.domains.push({
        switch: false
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    add(item) {
      console.log(this.addFlag);
      this.addFlag = true;
      this.addEdit({});
      console.log(11111);
      this.getChannelInfo(item);
    },
    addEdit(record) {
      console.log('record');
      console.log('ssssss');
      console.log(record);
      //record.groupType = record.groupType == 0 ? false: true;
      this.form.resetFields();
      this.getChannelInfo(record.channelCode);
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'groupType',
            'groupName',
            'groupDesc',
            'syncTagFlag',
            'relation'
          )
        );
      });
    },
    edit(record) {
      this.addFlag = false;
      console.log('record');
      console.log('ssssss');
      console.log(record);
      //record.groupType = record.groupType == 0 ? false: true;
      this.form.resetFields();
      this.getChannelInfo(record.channelCode);
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'groupType',
            'groupName',
            'groupDesc',
            'syncTagFlag',
            'relation'
          )
        );
      });
    },
    handleOk() {
      const that = this;
      console.warn('11111');
      // 列表验证
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          let formData = Object.assign(this.model, values);
          let httpurl = '';
          let method = '';
          formData.syncTagFlag = formData.syncTagFlag ? 1 : 0;
          // console.log("表单提交数据",formData)
          console.warn(formData.groupType);
          // console.log(this.userDataListSelections)
          if (formData.groupType === 0) {
            this.post(formData);
          } else {
            this.submit(formData);
          }
        }
      });
    },
    submit(formData) {
      let result = [];
      console.warn(this.$refs.dynamicValidateForm);
      if (this.$refs.dynamicValidateForm) {
        this.$refs.dynamicValidateForm.validate(valid => {
          if (valid) {
            // 触发表单验证
            let arr = this.dynamicValidateForm.domains;
            let obj = {};
            arr.forEach((ele, index) => {
              let type = '';
              let value = '';
              if (ele.column === 'area') {
                type = '=';
                value = ele.area1.join(',');
              } else if (ele.column === 'integralNum') {
                // 积分小程序
                type = 'between';
                value = ele.integralNum1 + ',' + ele.integralNum2;
              } else {
                type = ele[ele.column + 1];
                value = ele.value || ele[ele.column + 2];
              }
              obj = {
                columnName: ele.column,
                queryType: type,
                queryValue: value // 0-未知、1-男、2-女
              };
              result.push(obj);
            });
            console.log(result);
            this.post(formData, result);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    post(formData, result) {
      console.log(formData);
      if (this.addFlag) {
        postAction(process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/addGroup', {
          channelCode: this.channelInfo.code,
          ...formData,
          query: result === undefined ? '' : JSON.stringify(result),
          userIds: this.userDataListSelections.join(','),
          type: formData.relation === undefined ? '' : formData.relation
        }).then(res => {
          if (res.success && res.code === 200) {
            this.$message.success(res.message);
            this.dynamicValidateForm.domains = [];
            this.$emit('ok');
            this.visible = false;
          } else {
            this.$message.warning(res.message);
          }
        });
      } else {
        postAction(process.env.VUE_APP_CMS_WECHAT + '/wechatGroup/edit', {
          ...formData
        }).then(res => {
          if (res.success && res.code === 200) {
            this.$message.success(res.message);
            this.dynamicValidateForm.domains = [];
            this.$emit('ok');
            this.visible = false;
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    },
    searchQuery() {
      if (this.channelInfo.type !== 3) {
        this.getTagListAll();
      }
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatUser/list', {
        channelCode: this.channelInfo.code,
        blackFlag: 0
      }).then(res => {
        if (res.success && res.code === 200) {
          this.userList = res.result;
          //this.pagination.total = res.result.totalCount
        } else {
          this.userList = [];
          //this.totalCount = 0
        }
        //this.dataListLoading = false
      });
    },
    userHandleTableChange(pagination) {
      const page = { ...this.userPagination };
      this.userPagination.current = pagination.current;
      this.userPagination.pageSize = pagination.pageSize;
      this.userPageIndex = pagination.current;
      this.userPageSize = pagination.pageSize;
      this.userPagination = page;
    },
    handleCancel() {
      this.dynamicValidateForm.domains = [];
      this.$emit('close');
      this.visible = false;
    },
    handleSearch(e) {
      let data = JSON.parse(JSON.stringify(this.searchForm));
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatUser/list', {
        channelCode: this.channelInfo.code,
        blackFlag: 0,
        nikeName: data.nikeName,
        sex: data.sex,
        startTime: data.startTime,
        endTime: data.endTime,
        phone: data.phone,
        countStart: data.countStart,
        countEnd: data.countEnd
      }).then(res => {
        if (res.success && res.code === 200) {
          this.userList = res.result;
          //this.pagination.total = res.result.totalCount
        } else {
          this.userList = [];
          //this.totalCount = 0
        }
        //this.dataListLoading = false
      });
      console.log(data);
    },
    createChange(dates, dateStrings) {
      this.createValue = dates;
      this.searchForm.beginTime = dateStrings[0];
      this.searchForm.endTime = dateStrings[1];
    },
    getTagListAll() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/manage/wxUserTags/listAll', {
        appid: this.channelInfo.linkWechat
      }).then(res => {
        if (res.success && res.code === 200) {
          this.tagListAll = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //标签名称
    getTagName(tagidList) {
      let userTag = tagidList
        .split('[')[1]
        .split(']')[0]
        .split(',');
      let userTagContent = '';
      for (let i in userTag) {
        for (let j in this.tagListAll) {
          if (userTag[i] == this.tagListAll[j].id) {
            userTagContent += this.tagListAll[j].name + ',';
          }
        }
      }
      if (userTagContent.length > 0) {
        userTagContent = userTagContent.substr(0, userTagContent.length - 1);
      }
      return userTagContent;
    },
    //获取图片
    getHeadImageView: function(headimgurl) {
      return getFileAccessHttpUrl(headimgurl);
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.createValue = [];
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'name',
          'type',
          'sourceId',
          'token',
          'aesKey',
          'msgFormat',
          'status',
          'delFlag',
          'appId',
          'appSecret',
          'verified',
          'syncTagFlag',
          'relation'
        )
      );
    }
  }
};
</script>
<style lang="css">
.userCon-madal
  .ant-form-user
  .ant-row:first-child
  .ant-form-item-control-wrapper {
  margin-left: 16.66666667%;
}
.dynamic-delete-button {
  margin-left: 13px;
  margin-top: 14px;
}
</style>
